export const toastOptions = {
  position: "bottom-right",
  className: "toastContainer",
  progressClassName: "toastProgress",
};
